import { useMemo } from 'react';

import { useTranslation } from '@lyearn/i18n';
import { cn } from '@lyearn/style';
import Emoji from '@/components/Emoji';
import ReactionSelector from '@/features/reactions/components/ReactionSelector';

import { EmojiPickerProps } from './types';

const EmojiPicker = (props: EmojiPickerProps) => {
  const { t } = useTranslation();
  const { value, onChange } = props;

  const overrides = useMemo(() => {
    const rootClassname = value
      ? 'border-2 border-solid border-icon-active hover:bg-bg-tertiary'
      : 'hover:text-icon-primary active:text-icon-active hover:bg-bg-hover';

    return {
      MenuButton: {
        classes: {
          root: cn('w-34 h-34 flex items-center justify-center rounded-full', rootClassname),
          open: value ? 'bg-bg-tertiary' : 'text-icon-active bg-bg-hover',
          closed: value ? '' : 'text-icon-secondary',
        },
      },
      Icon: {
        className: 'w-32 h-32',
      },
    };
  }, [value]);

  return (
    <ReactionSelector
      overrides={overrides}
      tooltipTitle={value ? t('Common:EditEmoji') : t('Common:AddEmoji')}
      useAnchorAsContainer={false}
      onSelect={onChange}>
      {value ? <Emoji emoji={value} size={20} /> : null}
    </ReactionSelector>
  );
};

export default EmojiPicker;
